import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const runtimeEnv = (window as any).__env || {};
(window as any).__env = {
  apiUrl: runtimeEnv.apiUrl || environment.base_url,
  gateWay: runtimeEnv.gateWay || window.location.origin,
};

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, {
  applicationProviders: [
    provideZoneChangeDetection(),
  ],
})
  .catch(err => console.error(err));
